export default {"src":"/_next/static/media/postgresql-icon.96366d55.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};